import React from 'react';
import {View, Image, Text} from 'react-native';
import {CommonStyleSheet} from '../../Styles/Shared/CommonStyles';
import {LoginStyleSheet} from '../../Styles/LoginStyles';
import {Images} from '../../Constants/Images';

type LoginErrorProps = {
  error: string;
};

const LoginError = (props: LoginErrorProps): React.ReactElement => {
  return (
    <View style={LoginStyleSheet.container}>
      <View style={LoginStyleSheet.form}>
        <Image source={Images.FIRS_LOGO_DARK} style={LoginStyleSheet.logo} />
        <Text
          style={[
            CommonStyleSheet.inputError,
            {alignSelf: 'center', textAlign: 'center'},
          ]}>
          {props.error} Please contact support at{' '}
          {process.env.REACT_APP_SUPPORT_EMAIL}
        </Text>
        <Text style={LoginStyleSheet.footerText}>
          Built by EHS Analytics
          {'\n'}
          App Version {process.env.REACT_APP_VERSION_NAME}
        </Text>
      </View>
    </View>
  );
};

export default LoginError;
